import { TTagVariant } from '@pnld/components-web'

export const STATUS_VARIANT_MAP: Record<string, TTagVariant> = {
  CSV_UPLOADING: 'neutral',
  CSV_UPLOADING_FAILED: 'negative',
  CSV_PROCESSING: 'primary',
  CSV_PROCESSING_FAILED: 'negative',
  PREDICTION_TRIGGERING: 'primary',
  PREDICTION_TRIGGER_FAILED: 'negative',
  PREDICTION_TRIGGER_ABANDONED: 'neutral',
  PREDICTION_RUNNING: 'primary',
  PREDICTION_FAILED: 'negative',
  DONE: 'positive',
}

export const STATUS_SHORT_LABEL: Record<string, string> = {
  CSV_UPLOADING: 'Enviando arquivo',
  CSV_UPLOADING_FAILED: 'Erro no envio',
  CSV_PROCESSING: 'Processando dados',
  CSV_PROCESSING_FAILED: 'Erro no processamento',
  PREDICTION_TRIGGERING: 'Iniciando predição',
  PREDICTION_TRIGGER_FAILED: 'Erro ao iniciar a predição',
  PREDICTION_TRIGGER_ABANDONED: 'Predição cancelada',
  PREDICTION_RUNNING: 'Predição em andamento',
  PREDICTION_FAILED: 'Erro na predição',
  DONE: 'Predição concluída',
}
